import { useContext } from "react";
import { CellContext } from "@tanstack/react-table";
import styles from "./OptionsCell.module.scss";
import Dropdown from "../../../../../ui/Dropdown/Dropdown";
import IconButton from "../../../../../ui/IconButton/IconButton";
import { Copy, DotsVertical, Trash } from "../../../../../ui/Icon/Icon";
import EditableTableContext from "../EditableTable/EditableTableContext";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function OptionsCell({ cell }: CellContext<any, unknown>) {
  const { methods, disabled } = useContext(EditableTableContext);

  return (
    <div className={styles.optionsCell}>
      <Dropdown
        withinPortal
        asChild
        items={[
          {
            items: [
              {
                label: "Duplicate",
                disabled,
                IconComponent: Copy,
                onClick: () =>
                  methods?.append({
                    ...cell.row.original,
                    id: undefined,
                  }),
              },
              {
                label: "Delete",
                IconComponent: Trash,
                onClick: () => {
                  methods?.remove(cell.row.index);
                },
              },
            ],
          },
        ]}
      >
        <IconButton
          showTooltip={false}
          aria-label="Options"
          IconComponent={DotsVertical}
          size="small"
        />
      </Dropdown>
    </div>
  );
}

export default OptionsCell;
